import { useQuery } from '@tanstack/react-query';
import { GraphQLContext } from '@ui/providers/GraphQLProvider';
import { getQuery } from '@ui/queries/queries';
import { QueryKey } from '@ui/queries/queryKey';
import { useContext } from 'react';

export const useTransactionHistory = (address: string, first = 15) => {
  const client = useContext(GraphQLContext).historyClient;
  const query = getQuery(QueryKey.TRANSACTION_HISTORY)(client, address, first);
  return useQuery(query.queryKey, query.queryFn);
};
